import { render, staticRenderFns } from "./addmin.vue?vue&type=template&id=4aebe0de&scoped=true"
import script from "./addmin.vue?vue&type=script&lang=js"
export * from "./addmin.vue?vue&type=script&lang=js"
import style0 from "./addmin.vue?vue&type=style&index=0&id=4aebe0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebe0de",
  null
  
)

export default component.exports